import axiosInstance from "@/api/axiosInstance";
import { ENDPOINTS } from "@/constants/api";
import { requestHandler } from "@/helpers/requestHandler";
import type {
    AdminUserDetails,
    LBSubscriptionUpdateRequest,
    SubscriptionReconcileResponse,
} from "@/common/model/AdminUserDetails";

// Re-export types for backward compatibility
export type {
    AdminUserDetails,
    LBSubscriptionStatus,
    AuditEntry,
    LBSubscriptionUpdateRequest,
    SubscriptionReconcileResponse,
    SubscriptionReconcileItem,
} from "@/common/model/AdminUserDetails";

export const LBSubscriptionService = {
    async getStatus(userId: number): Promise<AdminUserDetails> {
        return requestHandler<AdminUserDetails>(async () => {
            const response = await axiosInstance.get(`${ENDPOINTS.ADMIN.USERS}/${userId}`);
            return response.data;
        }, "LBSubscriptionService -> getStatus");
    },

    async updateStatus(userId: number, updateRequest: LBSubscriptionUpdateRequest): Promise<AdminUserDetails> {
        return requestHandler<AdminUserDetails>(async () => {
            const response = await axiosInstance.put(
                `${ENDPOINTS.ADMIN.USERS}/${userId}/lb-email-subscription`,
                updateRequest
            );
            return response.data;
        }, "LBSubscriptionService -> updateStatus");
    },

    /**
     * Re-validate this user's subscription against Apple/Google (whichever platform(s) they have),
     * upsert the receipt + recompute the tier, and return a per-platform before/after diff (ADR-036).
     */
    async reconcileSubscription(userId: number): Promise<SubscriptionReconcileResponse> {
        return requestHandler<SubscriptionReconcileResponse>(async () => {
            const response = await axiosInstance.post(ENDPOINTS.ADMIN.RECONCILE_SUBSCRIPTION(userId));
            return response.data;
        }, "LBSubscriptionService -> reconcileSubscription");
    },
};
